module.exports = __webpack_public_path__ + "img/plus.7ece22c1.svg";